import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '../Buttons/PlainButtonOrLink';
export var Tabs = function (_a) {
    var className = _a.className, s = _a.viewClassNames, items = _a.items, activeIndex = _a.activeIndex, onChange = _a.onChange;
    var t = useTranslation().t;
    return (React.createElement("div", { className: classnames(s['root'], className) }, items.map(function (item) { return (React.createElement(PlainButtonOrLink, { key: item.index, className: classnames(s['tab'], item.index === activeIndex && s['active-tab']), onClick: function () { return onChange(item.index); }, biData: item.biData, "data-hook": item.dataHook },
        item.label || t(item.labelTransKey || ''),
        item.extras)); })));
};
Tabs.displayName = 'Tabs';
export default Tabs;
//# sourceMappingURL=Tabs.js.map